import React, { useState, useEffect } from "react";
import Popup from "reactjs-popup";
import { BiEdit } from "react-icons/bi";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import stylesEdit from "./person.module.css";

const apiUrl = process.env.REACT_APP_URL;

const ModalEdit = ({ profileData, updateInfo }) => {
  const [data, setData] = useState({
    first_name: "",
    last_name: "",
    country: "",
    city: "",
    birthdate: "",
    learned_language: "",
    native_language: "",
    description: "",
    education: "",
    hobbies: "",
  });

  const [languages, setLanguages] = useState([]);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const languagesRes = await axios.get(`${apiUrl}/search/languages`);

        if (languagesRes.status === 200) {
          setLanguages(languagesRes.data.languages);
        }
      } catch (e) {
        console.error("Failed to fetch languages data", e);
      }
    };
    fetchLanguages();
  }, []);

  // Fetch countries data from restcountries API
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const countriesRes = await axios.get(
          "https://restcountries.com/v3.1/all"
        );

        if (countriesRes.status === 200) {
          const countryNames = countriesRes.data.map(
            (country) => country.name.common
          );
          countryNames.sort((a, b) => a.localeCompare(b)); // Sort countries alphabetically
          setCountries(countryNames);
        }
      } catch (e) {
        console.error("Failed to fetch countries data", e);
      }
    };
    fetchCountries();
  }, []);
  // Update state when profileData changes
  useEffect(() => {
    if (profileData) {
      setData({
        first_name: profileData.first_name || "",
        last_name: profileData.last_name || "",
        country: profileData.country || "",
        city: profileData.city || "",
        birthdate: profileData.birthdate
          ? new Date(profileData.birthdate).toISOString().substr(0, 10)
          : "",
        learned_language: profileData.learned_language || "",
        native_language: profileData.native_language || "",
        description: profileData.description || "",
        education: profileData.education || "",
        hobbies: profileData.hobbies || "",
      });
    }
  }, [profileData]);

  const editData = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.put(
        `${apiUrl}/users/${profileData.username}`,
        data,
        {
          withCredentials: true,
        }
      );
      if (response.status === 200) {
        updateInfo(data);
      }
    } catch (error) {
      console.error("Failed to update user data", error);
    }
  };

  return (
    <Popup
      trigger={
        <button className={stylesEdit.button}>
          <BiEdit />
        </button>
      }
      modal
      nested
    >
      {(close) => (
        <div className={stylesEdit.modal}>
          <form
            className={stylesEdit.formEdit}
            onSubmit={(e) => {
              editData(e);
              close();
            }}
          >
            {/* First Name  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="first_name">First Name: </label>
              <input
                className={stylesEdit.input}
                id="first_name"
                name="first_name"
                type="text"
                value={data.first_name}
                onChange={(e) =>
                  setData({ ...data, first_name: e.target.value })
                }
              />
            </div>

            {/* Last Name  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="last_name">Last Name: </label>
              <input
                className={stylesEdit.input}
                id="last_name"
                name="last_name"
                type="text"
                value={data.last_name}
                onChange={(e) =>
                  setData({ ...data, last_name: e.target.value })
                }
              />
            </div>
            {/* City  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="city">City: </label>
              <input
                className={stylesEdit.input}
                id="city"
                name="city"
                type="text"
                value={data.city}
                onChange={(e) => setData({ ...data, city: e.target.value })}
              />
            </div>
            {/* Country */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="country">Country:</label>
              <select
                className={stylesEdit.input}
                id="country"
                name="country"
                value={data.country}
                onChange={(e) => setData({ ...data, country: e.target.value })}
              >
                <option value="">Select a country</option>
                {countries.map((country, index) => (
                  <option key={index} value={country}>
                    {country}
                  </option>
                ))}
              </select>
            </div>
            {/* Birth Date  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="birthdate">Birthdate: </label>
              <DatePicker
                className={stylesEdit.input}
                id="birthdate"
                selected={data.birthdate}
                onChange={(date) => setData({ ...data, birthdate: date })}
                dateFormat="dd/MM/yyyy"
                maxDate={new Date()}
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
              />
            </div>

            {/* Learned Language  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="learned_language">Learned Language: </label>
              <select
                className={stylesEdit.input}
                id="learned_language"
                name="learned_language"
                value={data.learned_language}
                onChange={(e) =>
                  setData({
                    ...data,
                    learned_language: e.target.value,
                  })
                }
              >
                <option value="">Select a language</option>
                {languages.map((languageObj, index) => (
                  <option key={index} value={languageObj.language}>
                    {languageObj.language}
                  </option>
                ))}
              </select>
            </div>

            {/* Native Language  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="native_language">Native Language: </label>
              <select
                className={stylesEdit.input}
                id="native_language"
                name="native_language"
                value={data.native_language}
                onChange={(e) =>
                  setData({
                    ...data,
                    native_language: e.target.value,
                  })
                }
              >
                <option value="">Select a language</option>
                {languages.map((languageObj, index) => (
                  <option key={index} value={languageObj.language}>
                    {languageObj.language}
                  </option>
                ))}
              </select>
            </div>
            {/* Personal description  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="description">Personal Description: </label>
              <input
                className={stylesEdit.input}
                id="description"
                type="text"
                name="description"
                value={data.description}
                onChange={(e) =>
                  setData({
                    ...data,
                    description: e.target.value,
                  })
                }
              />
            </div>

            {/* Education  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="education">Education: </label>
              <input
                className={stylesEdit.input}
                id="education"
                type="text"
                name="education"
                value={data.education}
                onChange={(e) =>
                  setData({
                    ...data,
                    education: e.target.value,
                  })
                }
              />
            </div>

            {/* Hobbies  */}
            <div className={stylesEdit.lineStyle}>
              <label htmlFor="hobbies"> Hobbies: </label>
              <input
                className={stylesEdit.input}
                id="hobbies"
                type="text"
                name="hobbies"
                value={data.hobbies}
                onChange={(e) =>
                  setData({
                    ...data,
                    hobbies: e.target.value,
                  })
                }
              />
            </div>
            <div className={stylesEdit.buttonSec}>
              <button className={stylesEdit.btn} type="submit">
                Save changes
              </button>
              <button className={stylesEdit.btn} onClick={close}>
                Cancel
              </button>
            </div>
          </form>
        </div>
      )}
    </Popup>
  );
};

export default ModalEdit;
